module.exports = __webpack_public_path__ + "img/media_web.2902566d.jpg";